import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { urlConstants } from '../../common/urlConstants';
import { DeleteWorkItemDto } from '../../models/deleteWorkItemDto';
import { Workflow, WorkflowQueueStatus } from '../../models/workflow.models';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  userGPID: string | null;
  systemId: string | null;

  constructor(private readonly http: HttpClient) {
    this.userGPID = localStorage.getItem("userGPID");
    this.systemId = localStorage.getItem('SelectedSystemId');
  }

  getAdminTreeWorkFlowData(): Observable<Workflow[]> {
    const url = `${environment.apiUrl}${urlConstants.adminTreeGetWorkflows}${this.userGPID}/${this.systemId}`;
    return this.http.get<Workflow[]>(url);
  }

  getWorkItemsDetails(workflowId: number, Id: number, maxItemCount: number = 50): Observable<any> {
    const url = `${environment.apiUrl}${urlConstants.adminTreeGetWorkItems}${this.userGPID}/${this.systemId}/${workflowId}/${Id}/${maxItemCount}`;
    return this.http.get<any>(url);
  }

  activateSuspendWorkItem(postObj: any): Observable<any> {
    const routeUrl = `${environment.apiUrl}${urlConstants.activateWorkItem}`;
    return this.http.post(routeUrl, postObj, { responseType: 'text' });
  }

  assignReleaseWorkItem(postObj: any): Observable<any> {
    const routeUrl = `${environment.apiUrl}${urlConstants.reAssignWorkItem}`;
    return this.http.post<any>(routeUrl, postObj);
  }

  assignReleaseWorkItemWorkFlow(postObj: any): Observable<any> {
    const routeUrl = `${environment.apiUrl}${urlConstants.reAssignWorkItemWorkFlow}`;
    return this.http.post<any>(routeUrl, postObj);
  }

  alterWorkItem(postObj: any): Observable<any> {
    const routeUrl = `${environment.apiUrl}${urlConstants.alterWorkItem}`;
    return this.http.post<any>(routeUrl, postObj);
  }

  getAdminQueueDetails(workflowId: number, queueID: number): Observable<WorkflowQueueStatus> {
    const url = `${environment.apiUrl}${urlConstants.adminTreeGetWorkQueues}${this.userGPID}/${this.systemId}/${workflowId}/${queueID}`;
    return this.http.get<WorkflowQueueStatus>(url);
  }

  deleteWorkItem(deleteWorkItemDto: DeleteWorkItemDto): Observable<any> {
    const deleteWorkItemUrl = `${environment.apiUrl}${urlConstants.deleteWorkItem}`;
    return this.http.post<any>(deleteWorkItemUrl, deleteWorkItemDto);
  }
}
